import { render, staticRenderFns } from "./EmptyCounselings.vue?vue&type=template&id=c982b49c&scoped=true"
import script from "./EmptyCounselings.vue?vue&type=script&lang=js"
export * from "./EmptyCounselings.vue?vue&type=script&lang=js"
import style0 from "./EmptyCounselings.vue?vue&type=style&index=0&id=c982b49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c982b49c",
  null
  
)

export default component.exports